// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header .p-breadcrumb {
  background-color: unset;
  border: none;
}

.header__nav {
  min-width: 0;
}

@media (max-width: 768px) {
  .header.wrapper {
    gap: 0.5rem;
  }

  .header .menu-toggle {
    flex-shrink: 0;
  }

  .header__breadcrumb {
    min-width: 0;
    overflow-x: auto;
  }

  .header__breadcrumb .p-breadcrumb-list {
    flex-wrap: nowrap;
  }

  .header__breadcrumb::-webkit-scrollbar {
    height: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/Header.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".header .p-breadcrumb {\n  background-color: unset;\n  border: none;\n}\n\n.header__nav {\n  min-width: 0;\n}\n\n@media (max-width: 768px) {\n  .header.wrapper {\n    gap: 0.5rem;\n  }\n\n  .header .menu-toggle {\n    flex-shrink: 0;\n  }\n\n  .header__breadcrumb {\n    min-width: 0;\n    overflow-x: auto;\n  }\n\n  .header__breadcrumb .p-breadcrumb-list {\n    flex-wrap: nowrap;\n  }\n\n  .header__breadcrumb::-webkit-scrollbar {\n    height: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
